
document.addEventListener('DOMContentLoaded', function () {
    var accordionTitles = document.querySelectorAll('.Faq_accordion_item--title');

    var firstAccordionItem = document.querySelector('.Faq_accordion_item');
    if (firstAccordionItem) {
        firstAccordionItem.classList.add('active_accordion');
    }

    accordionTitles.forEach(function (title) {
        title.addEventListener('click', function () {
            var accordionItem = this.closest('.Faq_accordion_item');
            var activeAccordionItem = document.querySelector('.Faq_accordion_item.active_accordion');

            if (activeAccordionItem && activeAccordionItem !== accordionItem) {
                activeAccordionItem.classList.remove('active_accordion');
            }

            accordionItem.classList.toggle('active_accordion');
        });
    });
});

window.addEventListener('load', function (event) {
    document.querySelectorAll('.faq__sidebar-link').forEach(link => {
        link.addEventListener('click', function () {
            document.querySelector('.faq__sidebar-link--active').classList.remove('faq__sidebar-link--active');
            this.classList.add('faq__sidebar-link--active');
        })
    })

}, false);
document.addEventListener('DOMContentLoaded', function () {
    document.querySelector('.faq__sidebar-title').addEventListener('click', function () {
        document.querySelector('.faq__sidebar').classList.toggle('collapse_sidebar');
    });

    document.querySelectorAll('.faq__sidebar-link').forEach(function (link) {
        link.addEventListener('click', function () {
            document.querySelector('.faq__sidebar').classList.remove('collapse_sidebar');
        });
    });

});